import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ILoggedInUser } from '../../interfaces/common/loggedInUser';
import { SearchParameters } from '../../shared/models/searchParameters.model';
import { PagedResult } from '../../shared/models/pagedResult.model';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { LoggedInUserService } from '../../services/common/logged-in-user.service';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { SearchRequestTypesChangesModel } from '../models/search-request-type-change.model';
import { RequestTypeChangesModel } from '../models/request-type-changes.model';
import { RequestAndLineTypeService } from '../services/request-and-line-types.service';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SearchRequestService } from '../../manage-request/services/search-request.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { CurrencyModes } from '../../shared/models/currency-modes.model';

@Component({
  selector: 'app-request-type-changes',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatProgressSpinnerModule, MatPaginatorModule, MatTableModule],
  templateUrl: './request-type-changes.component.html',
  styleUrl: './request-type-changes.component.scss'
})
export class RequestTypeChangesComponent implements OnInit{
  searchForm: FormGroup;
  user: ILoggedInUser;
  isAdmin: boolean = false;
  isLoading: boolean = false;
  totalCount: number;
  pageSize: number = 10;
  pageIndex: number;
  searchDone: boolean = false;
  displayedColumns: string[] = ['number', 'time', 'action', 'requestName','employeeType', 'mode', 'attachmentRequired', 'howPaid', 'skipAnalystReview', 'doaType', 'approver1', 'approver2', 'approver3', 'approver4', 'approver5', 'actionBy'];
  currencyModes = [];
  searchRequestParams: SearchParameters<SearchRequestTypesChangesModel>;
  pagedData: PagedResult<RequestTypeChangesModel[]>;
  dataSource: MatTableDataSource<RequestTypeChangesModel>;
  searchRequestService: SearchRequestService = inject(SearchRequestService);
  requestTypesList = toSignal(this.searchRequestService.getAllRequestTypes(), { rejectErrors: true });
    
  constructor(
    private userService: LoggedInUserService,
    private fb: FormBuilder,
    private requestAndLineTypeService: RequestAndLineTypeService ) 
    {}

  ngOnInit(): void {
    this.currencyModes = Object.keys(CurrencyModes);
    this.searchForm = this.fb.group({
      requestType: new FormControl(''),          
      requestTypeName: new FormControl(''),
      currencyMode: new FormControl(''),
      fromDate: new FormControl(''),
      toDate: new FormControl('')
    });

    this.userService.currentUser$.subscribe(data => {
      this.user = data;
      if(this.user != null && this.user.adminRight){
        this.isAdmin = this.user.adminRight;        
      }      
    });
  }

  submitForm(): void {
    this.searchRequestParams = {
      query: {
        requestType: this.searchForm.get('requestType').value || null,
        requestTypeName: this.searchForm.get('requestTypeName').value || null,
        currencyMode: CurrencyModes[this.searchForm.get('currencyMode').value as keyof typeof CurrencyModes] || "",
        fromDate: this.searchForm.get('fromDate').value || null,
        toDate: this.searchForm.get('toDate').value || null
      },
      pageIndex: 0,
      pageSize: 10,
      userEmail: this.user.userEmail      
    };
    
    this.search();
  }
    
  search() {
    if(this.isAdmin){
      this.isLoading = true;
      this.requestAndLineTypeService.searchRequestTypesChanges(this.searchRequestParams)
        .subscribe(data => {
          this.pagedData = data;
          this.pageSize = this.pagedData.pageSize;
          this.totalCount = this.pagedData.totalCount;      
          this.dataSource = new MatTableDataSource<RequestTypeChangesModel>(this.pagedData.items);
          this.isLoading = false;
          this.searchDone = true;
      });
    }
    else{
      this.dataSource = new MatTableDataSource<RequestTypeChangesModel>([]);
    }
  }
      
  public pageChangeEvent(event?: PageEvent){
    this.searchRequestParams.pageIndex = event.pageIndex;
    this.searchRequestParams.pageSize = event.pageSize;
    this.search();
  }  

}
